export default "__VITE_ASSET__NFwB2D3B__"